import { Expose } from "class-transformer";

export class UpdatePaymentMethodDto {
  @Expose()
  name: string;

  @Expose()
  requiresAccountingReconciliation: boolean;

  @Expose()
  canBeIncludedInExpenseSheet: boolean;

  @Expose()
  isDefaultForPurchaseOrders?: boolean;
}
